import React, { useState } from "react";
import { getPostsByLanguage } from "../data/blogPosts";
import "./Blog.css";

const Blog = ({ t, language }) => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const posts = getPostsByLanguage(language);

  const categories = ["all", ...new Set(posts.map((post) => post.category))];
  const filteredPosts =
    selectedCategory === "all"
      ? posts
      : posts.filter((post) => post.category === selectedCategory);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (language === "fa") {
      return new Intl.DateTimeFormat("fa-IR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(date);
    }
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  return (
    <section id="blog" className="section blog-section">
      <h2 className="section-title">{t.blog.title}</h2>
      <p className="blog-description">{t.blog.description}</p>

      <div className="blog-filters">
        {categories.map((category) => (
          <button
            key={category}
            className={`filter-btn ${
              selectedCategory === category ? "active" : ""
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category === "all"
              ? t.blog.all
              : language === "fa"
              ? category
              : category}
          </button>
        ))}
      </div>

      <div className="blog-container">
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-image">
                {post.image && (
                  <img
                    src={
                      post.image.startsWith("http")
                        ? post.image
                        : process.env.PUBLIC_URL + post.image
                    }
                    alt={post.title}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                )}
                <div className="blog-category">{post.category}</div>
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-date">{formatDate(post.date)}</span>
                </div>
                <h3 className="blog-title">{post.title}</h3>
                <p className="blog-excerpt">{post.excerpt}</p>
                <div className="blog-tags">
                  {post.tags.map((tag, index) => (
                    <span key={index} className="blog-tag">
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href={`#blog/${post.slug}`}
                  className="blog-read-more"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = `blog/${post.slug}`;
                    window.dispatchEvent(new HashChangeEvent("hashchange"));
                  }}
                >
                  {t.blog.readMore} {language === "fa" ? "←" : "→"}
                </a>
              </div>
            </article>
          ))
        ) : (
          <div className="blog-empty">
            <p>{t.blog.noPosts}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
